import { useNavigate } from "react-router-dom";
import { routes } from "consts";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { useToaster, getApiErrorMessage } from "utils";
import { shopApi } from "api/shop";
import { LandingPageForm, LandingPageFormValues } from "./Forms/LandingPageForm";
import { useState } from "react";

export const LandingPageAddPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: LandingPageFormValues) => {
    setIsLoading(true);
    try {
      const response = await shopApi.createLandingPage(data);
      showSuccess("Dodano nową stronę");
      navigate(routes.SHOP_LANDING_PAGES_EDIT(response.data?.id?.toString()));
    } catch (e) {
      showError(getApiErrorMessage(e, "Nie udało się dodać nowej strony"));
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[{ title: "Sklep", path: routes.SHOP_LANDING_PAGES }, { title: "Nowa strona" }]}
        headerText="Nowa strona"
      />
      <LandingPageForm onSubmit={onSubmit} isLoading={isLoading} />
    </PageMain>
  );
};
